import request from "@/utils/request";

export function getRegions(params) {
  return request({
    url: "/api/admin/regions/",
    method: "get",
    params,
  });
}
export function getRegionById(regionId) {
  return request({
    url: `/api/admin/regions/${regionId}/`,
    method: "get",
  });
}
/**
 * @example {
  "id": 0,
  "name": "Нижегородская область"
}
 */
export function createRegion(data) {
  return request({
    url: `/api/admin/regions/`,
    method: "post",
    data,
  });
}
export function deleteRegion(regionId) {
  return request({
    url: `/api/admin/regions/${regionId}/`,
    method: "delete",
  });
}
export function updateRegion(regionId, data) {
  return request({
    url: `/api/admin/regions/${regionId}/`,
    method: "patch",
    data,
  });
}
